import { useFormContext, Controller } from 'react-hook-form';
import {
  Switch,
  FormControlLabel,
  FormControlLabelProps,
  SwitchProps,
  useTheme,
} from '@mui/material';

type IProps = Omit<FormControlLabelProps, 'control'>;

interface Props extends IProps {
  name: string;
  switchProps?: SwitchProps;
}

export default function RHFSwitch({ name, switchProps = {}, ...other }: Props) {
  const { control } = useFormContext();
  const theme = useTheme();
  const { sx, ...restSwitchProps } = switchProps;

  return (
    <FormControlLabel
      control={
        <Controller
          name={name}
          control={control}
          render={({ field }) => (
            <Switch
              {...field}
              checked={field.value}
              sx={{
                ...{
                  '& .MuiSwitch-thumb': {
                    boxShadow: `-.5px 2px 2px ${theme.palette.grey[500_48]}`,
                  },
                },
                ...sx,
              }}
              {...restSwitchProps}
            />
          )}
        />
      }
      {...other}
    />
  );
}
